import { restApi } from "@/api/index";

/**
 * Get the referrer from the referral code passed the user settings
 * @param {ReferralQuery} data - The data with the referral code to query
 * @returns {Promise<{avatar: string, name: string}>} Promise representing the API response
 */
export const getReferral = (data) => {
  return restApi.get(`/referral/${data.referral_code}`);
};
